import React from 'react';
// Switch to Storefront API implementation to fix checkout issues
import { ShopContextProvider } from './src/context/ContextStorefront';
// import { ShopContextProvider } from './src/context/Context';

export const wrapRootElement = ({ element }) => {
  return <ShopContextProvider>{element}</ShopContextProvider>;
};
